import moment from "moment";
import numeral from "numeral";

export const ledgerDetailsConversion = (details) => {
  if (!details) {
    return null;
  }
  let starterValue = details.initialBalance;
  let workedRows = [];
  if (details && details.entries) {
    details.entries.map((detail) => {
      starterValue = detail.credit !== 0 ? starterValue - detail.credit : starterValue + detail.debit;
      return workedRows.push({
        originalEntryId: detail.id,
        "Data registrazione": moment(detail.postingDate).format("DD/MM/YYYY"),
        Causale: detail.reasonId ? detail.reasonId.split(":reasons/")[1] : "",
        Importo: numeral(detail.credit !== 0 ? detail.credit : detail.debit).format("0,0.00") + " €",
        " ": detail.credit !== 0 ? "A" : "D",
        Totale: numeral(detail.cumulativeBalance).format("0,0.00") + " €",
        "N. documento": detail.docNumber,
        "Data documento":  moment(detail.docDate).format("DD/MM/YYYY"),
        "Causale": detail.reasonDescription,
        "hasDetails": true
      });
    });
  }

  let reportJson = {
    header: ["Data registrazione", "N. documento", "Data documento", "Causale", "Importo", " ", "Totale", "  "],
    rows: workedRows
  };
  return reportJson;
};
